import { QueryClient, QueryCache } from "react-query";
import { persistQueryClient } from "react-query/persistQueryClient-experimental";
import { createWebStoragePersistor } from "react-query/createWebStoragePersistor-experimental";
import { logErrorMessage } from "../helpers/toast.helper";

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error: any, query: any) => {
            logErrorMessage(query.queryKey?.[0]);
        },
    }),
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: 1000 * 60 * 60, // 1h — inactive queries GC'd after 1 hour
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            retry: 1,
        },
    },
});

const PERSISTED_KEYS = new Set(["categories", "try2combo", "kidscombo", "filterTags"]);

persistQueryClient({
    queryClient,
    persistor: createWebStoragePersistor({ storage: window.localStorage }),
    maxAge: 1000 * 60 * 60, // 1h — discard persisted cache older than 1h on app load
    dehydrateOptions: {
        shouldDehydrateQuery: (query) => PERSISTED_KEYS.has(query.queryKey?.[0] as string),
    },
});

/* Fix for react-query types with React 18 */
declare module "react-query/types/react/QueryClientProvider" {
    export interface QueryClientProviderProps {
        children?: React.ReactNode;
    }
}
